import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { Profile } from '@ixicare/resources';
import { ProfileConfiguration } from '@ixicare/resources';
import { useStores } from '~store/utils';

export function useProfileConfiguration(profileId: number) {
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey: ['profileConfiguration', profileId],
    queryFn: () => Profile.getProfileConfiguration(profileId),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: profileId > -1,
  });
  const patchConfigMutation = useMutation({
    mutationFn: (body: ProfileConfiguration) => Profile.patchProfileConfiguration(profileId, body),
    onSuccess: (data) => {
      queryClient.setQueryData(['profileConfiguration', profileId], data);
    },
  });

  return {
    mutate: patchConfigMutation.mutate,
    isMutating: patchConfigMutation.isPending,
    isLoading: query.isLoading,
    data: query.data,
  };
}

export function useProfile(profileId?: number) {
  const { data: resident } = useQuery({
    queryKey: ['profile', profileId],
    queryFn: () => Profile.getProfile(profileId ?? -1),
    enabled: typeof profileId === 'number',
  });
  return resident;
}

export function useUserType() {
  const { auth } = useStores();
  return auth.userType;
}
